import { render, staticRenderFns } from "./Tablavideos.vue?vue&type=template&id=5560e7fb"
import script from "./Tablavideos.vue?vue&type=script&lang=js"
export * from "./Tablavideos.vue?vue&type=script&lang=js"
import style0 from "./Tablavideos.vue?vue&type=style&index=0&id=5560e7fb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports